import { useSelector } from 'react-redux';
import { ROLES } from 'src/constants/auth';
import { getAuth } from 'src/redux/slices/auth';
import { Role } from 'src/schemas/Role';

import Permissions from './permissions';
import PERMISSIONS_BY_ROLE from './permissionsByRole';

const usePermissions = () => {
  const { superAdminToken, role, currentAccount } = useSelector(getAuth);

  const hasPermission = (permission: Permissions): boolean => {
    const userRole: Role = superAdminToken ? ROLES.SUPER_ADMIN : role;

    return PERMISSIONS_BY_ROLE[userRole]?.includes(permission);
  };

  const hasAccountPermission = (permission: string, account?: Account): boolean => {
    if (permission === 'contacts') {
      return !!currentAccount?.settings?.data?.contacts?.list?.value;
    }
    if (permission === 'deals') {
      const accountToUse = account || currentAccount;
      return !!accountToUse?.settings?.data?.dealer?.deals?.value;
    }

    if (permission === 'pricing') {
      const accountToUse = account || currentAccount;
      return !!accountToUse?.settings?.data?.dealer?.pricing?.value;
    }

    return false;
  };

  return {
    hasPermission,
    hasAccountPermission,
  };
};

export default usePermissions;
